import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AmaLogo({ size = 34, showText = true, className = "", useUploaded = true }) {
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    if (!useUploaded) return;
    api.defaults.baseURL && fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/public`)
      .then((r) => r.json()).then((d) => setLogo(d?.logo_data_url || null)).catch(() => {});
  }, [useUploaded]);

  if (logo) {
    return (
      <div className={`flex items-center ${className}`}>
        <img src={logo} alt="AMA Sicurezza" style={{ height: size, width: "auto", maxWidth: size * 5 }} className="object-contain" />
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="ama-g" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
            <stop stopColor="#d63384" />
            <stop offset="1" stopColor="#6f42c1" />
          </linearGradient>
        </defs>
        <path
          d="M50 8 C 24 8, 8 26, 8 50 C 8 72, 24 92, 50 92 C 76 92, 92 72, 92 50 C 92 26, 76 8, 50 8 Z M 50 20 C 68 20, 80 34, 80 50 C 80 66, 68 80, 50 80 C 32 80, 20 66, 20 50 C 20 34, 32 20, 50 20 Z"
          stroke="url(#ama-g)" strokeWidth="4" fill="none"
        />
        <circle cx="35" cy="40" r="4" fill="#d63384" />
        <circle cx="65" cy="40" r="4" fill="#6f42c1" />
        <path d="M28 60 Q 40 74, 50 60 Q 60 74, 72 60" stroke="url(#ama-g)" strokeWidth="4" fill="none" strokeLinecap="round" />
      </svg>
      {showText && (
        <div className="leading-tight">
          <div className="font-heading font-bold text-lg tracking-tight ama-gradient-text">AMA</div>
          <div className="text-[10px] font-semibold text-[#6f42c1] tracking-[0.2em] uppercase -mt-0.5">Sicurezza</div>
        </div>
      )}
    </div>
  );
}
